export default __webpack_public_path__ + "static/media/10.9d494d3d.png";